import { useI18n } from "../../i18n";
import styles from "./Badge.module.css";

import check from "../../assets/icons/check.png";

import type { JSX } from "react";

export type BadgeProps = {
  label: string;
  useIcon?: string;
};

const Badge = (props: BadgeProps): JSX.Element => {
  const { label = "", useIcon = "checked" } = props;
  const { t } = useI18n();

  const iconsMap: Record<string, string> = {
    checked: check,
  };

  return (
    <div className={styles.badge}>
      {<img src={iconsMap[useIcon]} alt={`${useIcon} icon`} />}
      {t(label)}
    </div>
  );
};

export { Badge };
